import { LayoutProps } from "components/layout";
import React, { createContext, useState } from "react";
import { Route } from 'react-router-dom';
import { AppRouteType } from "__utils/type";

interface AppRouteProps extends AppRouteType {
  component: React.Component<any> | any;
}

export const LayoutContext = createContext<any>({ layoutProps: {}, SetLayoutProps: () => { } });

const AppRoute: React.FC<AppRouteProps> = (props: AppRouteProps) => {
  const [ layoutProps, SetLayoutProps ] = useState<LayoutProps>({});
  const { component: Component, layout: MainLayout, ...rest } = props;

  return (
    <Route
      { ...rest }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render={ () =>
        <LayoutContext.Provider value={ { layoutProps, SetLayoutProps } }>
          <MainLayout
            config={ layoutProps.config }
            breadcrumbList={ layoutProps.breadcrumbList }
            hideTopPaddingMobile= { layoutProps.hideTopPaddingMobile }
            showBseInfoForDesktop={ layoutProps.showBseInfoForDesktop }
            showBseInfoForMobile={ layoutProps.showBseInfoForMobile }
            showCopyrightInfoForDesktop={ layoutProps.showCopyrightInfoForDesktop }
            showCopyrightInfoForMobile={ layoutProps.showCopyrightInfoForMobile }
            showGlobalFooter={ layoutProps?.showGlobalFooter }
            desktopWidth={layoutProps?.desktopWidth}
          >
            <Component />
          </MainLayout>
        </LayoutContext.Provider> }
    />


  );
};

export default AppRoute;